import styled from 'styled-components';

export const SettingsContainerStyled = styled.div`
    padding: 32px;
`;

export const SettingsStyled = styled.div`
    flex: 1 1 auto;

    > *:not(:first-child) {
        border-top: 1px solid var(--color-main);
    }

    ${SettingsContainerStyled} {
        &:not(:first-child) {
            padding-top: 24px;
        }

        &:not(:last-child) {
            padding-bottom: 24px;
        }
    }
`;
